<template>
  <div class="opinion" :style="{ 'paddingTop': statusBar + 'rem' }" ref="getheigh">
    <Headerd title="意见或建议" :back="true" left="返回" :white="true" :save=save />
    <div class="opinionmain" ref="getheight">
      <div class="production">
        <p>欢迎就掌上单一窗口的功能与使用感受提出您宝贵的意见或建议，我们将不断努力并在后续版本中进行完善改进。</p>
      </div>
      <van-form validate-first>
        <div class="write">
          <p class="tittle">详情</p>
          <p class="red">*</p>
          <van-field :rules="[{ required: true, validator: msgvalidator, message: '请在此填写10个汉字以上的意见或建议' }]"
            v-model="message" rows="6" type="textarea" maxlength="500" placeholder="请在此填写10个汉字以上的意见或建议" show-word-limit>
          </van-field>
          <p class="tittle">电子邮箱（选填）</p>
          <van-field name="validator" :rules="[{ required: false, validator: emailvalidator, message: '请填写正确的邮箱地址' }]"
            class="emalil" v-model="emali" placeholder="邮箱地址（选填）"></van-field>
          <p class="tittle" style="color:#939398;margin-top:16px">请了解以下内容</p>
          <p class="tittle" style=" font-weight: 100;color:#939398;font-size:12px;margin-top:6px">
            ·禁止提交违反法律法规和政策、辱骂或语言暴力、诽谤、侮辱、或诋毁他人内容。</p>
          <p class="tittle" style=" font-weight: 100;color:#939398;font-size:12px;margin-top:10px">
            ·为了保护您的账户安全，请勿填写如身份证等敏感的个人信息。</p>
        </div>
        <div class="btn">
          <button @click="fromSubmit(checkMsg, checkMail)" class="btn1">
            提交
          </button>

        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import "@/views/css/opinion.scss";
import Headerd from "@/components/Headerd";
import { Field, Form } from "vant";
export default {
  name: "notice",
  /**
   * 初始化数据
   */
  data() {
    return {
      statusBar: 0,
      message: "",
      emali: "",
      save: false,
      checkMsg: false,
      checkMail: true,
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
  },
  updated() { },
  watch: {
    message(n, o) {
      if (n !== "") {
        this.save = true;
      } else {
        this.save = false;
      }
    },
  },
  /**
   * 方法
   */
  methods: {
    fromtest() {
      this.$nativeApi.getImage(3, '0', '2', '1', 'jpg;png;jpeg').then((res) => {
        console.log(res);
      })
    },
    msgvalidator(val) {
      if (val.length < 10) {
        return false;
      }
      this.checkMsg = true;
      return true;
    },
    emailvalidator(val) {
      if (val !== "") {
        var reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
        console.log("this.checkMail = false;");
        console.log(reg.test(val));
        if (!reg.test(val)) {
          this.checkMail = false;
        } else {
          this.checkMail = true;
        }
        return reg.test(val);
      }
      return true;
    },
    fromSubmit(checkMsg, checkMail) {
      let data = {
        email: this.emali,
        feedbackContent: this.message,
      };
      if (checkMsg && checkMail) {
        if (!this.message == "") {
          this.$http1
            .post("/zsdyckserver/app/feedback", data)
            .then((res) => {
              if (res.resultFlag == 0) {
                this.$toast(res.failInfo);
              } else if (res.resultFlag == 1) {
                this.$toast("提交成功，感谢您的参与");
                setTimeout(() => {
                  this.$tool.callModule("closePage");
                }, 1000);
              }

              // this.$router.push("/swdesk");
            })
            .catch((err) => { });
        }
      }
    },
  },

  components: {
    Headerd,
    [Form.name]: Form,

    [Field.name]: Field,
  },
};
</script>

<style scoped lang="scss">
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 22px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid white;
  background: white;

  .btn1 {
    background: $ButtonColor;
    border: 1px solid $lineColor;
    border-radius: 4px;
    width: 90px;
    height: 35px;
    font-size: 14px;
    color: white;
  }
}

.opinion {

  //width: 100%;
  .opinionmain {
    overflow: auto;

    .production {
      padding: 16px 16px;

      p {
        font-size: 12px;
      }
    }

    .write {
      background: white;
      padding: 16px 0px;

      .tittle {
        margin: 0 6px 0 16px;
        font-size: 14px;
        font-weight: bold;
        display: inline-block;
      }

      .red {
        color: red;
        font-size: 14px;
        display: inline-block;
      }
    }
  }
}
</style>